import { HistorySearchApi } from 'ctp-history-service';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const HistorySearchApiCaller = new HistorySearchApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export default HistorySearchApiCaller;
